/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

enum MetricsType {
  TimeToFirstFrame,
  ChannelCreationTimeToFirstFrame,
  Stalled,
  Buffering,
  SetupCompleted,
  SetupFailed,
  RoundTripTime,
  DownlinkThroughputCapacity,
  NetworkType,
  ResolutionChanged,
  ApplicationForeground,
  ApplicationBackground
}

export default MetricsType;